export var IceRestartReason;
(function (IceRestartReason) {
    IceRestartReason["FailedState"] = "FailedState";
    IceRestartReason["Reconnect"] = "Reconnect";
    IceRestartReason["RefreshTURNCredentials"] = "RefreshTURNCredentials";
    IceRestartReason["Consume"] = "Consume";
    IceRestartReason["Produce"] = "Produce";
    IceRestartReason["Debug"] = "Debug";
    IceRestartReason["Unknown"] = "Unknown";
})(IceRestartReason || (IceRestartReason = {}));
//# sourceMappingURL=IceRestartReason.js.map